import * as actionTypes from 'src/app/state/actions/types';
import type { Dispatch, RootState } from 'src/app/state/store';

export const fetchMedicationGuideForNDC = (ndc: string) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const state = getState();
    const { client } = state;

    dispatch({ type: actionTypes.GET_MEDICATION_GUIDES_REQUEST });

    try {
      const medicationGuidesResponse = await client.getMedicationGuideForNDC(ndc);
      const sanitizedHtml = medicationGuidesResponse?.data?.html;

      dispatch({
        type: actionTypes.GET_MEDICATION_GUIDES_SUCCESS,
        ndc,
        payload: sanitizedHtml,
      });
    } catch (err) {
      dispatch({ type: actionTypes.GET_MEDICATION_GUIDES_FAILURE, error: err });
    }
  };
};
